import { ArtworksFilterState, DEFAULT_ARTWORK_IDS_FILTER_VALUE } from './artworks.types';

export const getDefaultArtworkIdsFilter = (): ArtworksFilterState => ({
  ids: DEFAULT_ARTWORK_IDS_FILTER_VALUE,
});
export const defaultArtistsFilter = getDefaultArtworkIdsFilter();
